let logId = 0;
let logs = [];
let subscribers = [];

const logger = {
  logs() {
    return [...logs];
  },

  subscribe(callback) {
    subscribers.push(callback);
    callback([...logs]);
    
    return () => {
      subscribers = subscribers.filter(sub => sub !== callback);
    };
  },

  log(level, message, data = {}) {
    const logEntry = {
      id: ++logId,
      timestamp: new Date().toISOString(),
      level,
      message,
      ...data
    };

    logs.push(logEntry);
    
    // Keep only last 100 logs
    if (logs.length > 100) {
      logs = logs.slice(-100);
    }

    // Notify subscribers
    subscribers.forEach(callback => callback([...logs]));

    // Console log for development
    if (console[level]) {
      console[level](message, data);
    } else {
      console.log(`[${level.toUpperCase()}]`, message, data);
    }

    return logEntry;
  },

  info(message, data = {}) {
    return this.log('info', message, data);
  },

  warn(message, data = {}) {
    return this.log('warn', message, data);
  },

  error(message, data = {}) {
    return this.log('error', message, data);
  },

  success(message, data = {}) {
    return this.log('success', message, data);
  },

  logRequest(api, method, url, requestData) {
    return this.log('info', `${method} ${url}`, {
      api,
      method,
      url,
      request: requestData,
      type: 'request'
    });
  },

  logResponse(logId, status, responseData, duration, headers = {}) {
    const existingLogIndex = logs.findIndex(log => log.id === logId);
    
    if (existingLogIndex !== -1) {
      logs[existingLogIndex] = {
        ...logs[existingLogIndex],
        status,
        response: responseData,
        duration,
        headers,
        type: status >= 400 ? 'error' : 'success'
      };
      
      subscribers.forEach(callback => callback([...logs]));
    }
  },

  logError(logId, error, status = 0) {
    const existingLogIndex = logs.findIndex(log => log.id === logId);
    
    if (existingLogIndex !== -1) {
      logs[existingLogIndex] = {
        ...logs[existingLogIndex],
        error: error.message || error,
        status: status || 500,
        type: 'error'
      };
      
      subscribers.forEach(callback => callback([...logs]));
    } else {
      this.error('API Error', {
        error: error.message || error,
        status: status || 500
      });
    }
  },

  clear() {
    logs = [];
    subscribers.forEach(callback => callback([]));
  }
};

export { logger };